import PropTypes from "prop-types";
import IntersectionObserver from "../IntersectionObserver";
import styles from "./index.css";

const LazyLoadObserver = ({ itemBlocks, totalItems, onIntersection }) =>
  !itemBlocks.length ||
  (itemBlocks.length === 1 && !itemBlocks[0].observed) ? null : (
    <span aria-hidden={true} className={styles.lazyLoadObserver}>
      {itemBlocks.map(
        ({ observed, start, end, bufferedStart, bufferedEnd }) => (
          <div
            key={start}
            className={styles.lazyLoadBlock}
            style={{
              height: `calc(${
                (bufferedEnd - bufferedStart + 1) / totalItems
              } * 100%)`
            }}
          >
            {observed && (
              <IntersectionObserver
                onIntersection={onIntersection}
                watchOptions={{
                  start,
                  end,
                  bufferedStart,
                  bufferedEnd
                }}
              />
            )}
          </div>
        )
      )}
    </span>
  );

LazyLoadObserver.propTypes = {
  itemBlocks: PropTypes.arrayOf(
    PropTypes.shape({
      observed: PropTypes.bool.isRequired,
      start: PropTypes.number.isRequired,
      end: PropTypes.number.isRequired,
      bufferedStart: PropTypes.number.isRequired,
      bufferedEnd: PropTypes.number.isRequired
    }).isRequired
  ).isRequired,
  totalItems: PropTypes.number.isRequired,
  onIntersection: PropTypes.func.isRequired
};

export default LazyLoadObserver;
